import { defineMessages } from "react-intl";
import { stdnum } from "stdnum";

import { removeNonAlphanumeric } from "../tax-information.utils";

const DE_TAX_IDS = {
  HANDELSREGISTERNUMMER: "HANDELSREGISTERNUMMER",
  STEUERID_STEUERNUMMER: "STEUERID_STEUERNUMMER",
};

const DE_TAX_IDS_META = {
  [DE_TAX_IDS.HANDELSREGISTERNUMMER]: {
    type: DE_TAX_IDS.HANDELSREGISTERNUMMER,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.handelsregisternummer_short_name",
        defaultMessage: "Commercial Register Number",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.handelsregisternummer_name",
        defaultMessage: "Commercial Register Number",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.handelsregisternummer_full_name",
        defaultMessage: "Handelsregisternummer (HRB)",
      },
    }),
    validationFn: (value) => {
      const validationPattern = /^(HRB\s*\d{3,6}\s*[A-Z]?)$/i;
      return {
        isValid: validationPattern.test(value),
        compact: removeNonAlphanumeric(value),
        isIndividual: false,
        isCompany: true,
      };
    },
    format: "HRB 000000 A",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.handelsregisternummer_format",
        defaultMessage:
          "HRB followed by digits and optional letter (e.g., HRB 247469 B)",
      },
    }),
  },
  [DE_TAX_IDS.STEUERID_STEUERNUMMER]: {
    type: DE_TAX_IDS.STEUERID_STEUERNUMMER,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.steuerid_steuernummer_short_name",
        defaultMessage: "Tax ID",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.steuerid_steuernummer_name",
        defaultMessage: "German Tax ID",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.steuerid_steuernummer_full_name",
        defaultMessage: "German Tax ID (Tax-ID/Tax Number)",
      },
    }),
    validationFn: (value) => {
      // STEUERNUMMER
      const idnr = stdnum.DE.idnr.validate(value);
      // STEUERID
      const stnr = stdnum.DE.stnr.validate(value);
      return idnr.isValid ? idnr : stnr;
    },
    format: "00 000 000 000 or 00000 00000",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.steuerid_steuernummer_format",
        defaultMessage: "10-11 digits",
      },
    }),
  },
};

const DE_VAT_IDS = {
  UST_IDNR: "UST_IDNR",
};

const DE_VAT_IDS_META = {
  [DE_VAT_IDS.UST_IDNR]: {
    type: DE_VAT_IDS.UST_IDNR,
    ...defineMessages({
      shortNameMessageDescriptor: {
        id: "hosting.tax_information_section.ust_idnr_short_name",
        defaultMessage: "VAT ID",
      },
      nameMessageDescriptor: {
        id: "hosting.tax_information_section.ust_idnr_name",
        defaultMessage: "Value-Added Tax Identification Number",
      },
      fullNameMessageDescriptor: {
        id: "hosting.tax_information_section.ust_idnr_full_name",
        defaultMessage: "Value-Added Tax Identification Number (VAT ID)",
      },
    }),
    validationFn: stdnum.DE.vat.validate,
    format: "DE 000 000 000",
    ...defineMessages({
      formatStringMessageDescriptor: {
        id: "hosting.tax_information_section.ust_idnr_format",
        defaultMessage: "2 letters, 9 digits",
      },
    }),
  },
};

export { DE_TAX_IDS, DE_TAX_IDS_META, DE_VAT_IDS, DE_VAT_IDS_META };
